import { render, staticRenderFns } from "./PartnerCreditRechargeForm.vue?vue&type=template&id=00b822f3&"
import script from "./PartnerCreditRechargeForm.vue?vue&type=script&lang=js&"
export * from "./PartnerCreditRechargeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports